// Thin wrapper over the unified TrackingStatusBadge. Exists so callers can
// render `<SowStatusPill status={...}/>` without re-stating `kind="sow"` at
// every call site, mirroring MeetingStatusPill / the deliverable / milestone
// badge patterns. All visual behaviour lives in TrackingStatusBadge — this
// keeps the per-tab API readable and gives us a single anchor to evolve when
// a future tone variation is added (e.g. "overdue" cue on Active SOWs whose
// end date has passed).

import TrackingStatusBadge from "../shared/TrackingStatusBadge";
import type { SowStatus } from "../../../../types";

interface SowStatusPillProps {
  status: SowStatus;
}

export default function SowStatusPill({ status }: SowStatusPillProps) {
  return <TrackingStatusBadge kind="sow" status={status} />;
}
